import { css } from 'aphrodite';
import * as React from 'react';
import { styles } from './styles';

interface AddNewTagFooterProps {
	/**
	 * The search query text to display in the tag pill
	 */
	searchQuery: string;

	/**
	 * Callback invoked when the "Add New Tag" button is clicked
	 */
	onAddTag: (tagName: string) => void;
}

/**
 * Footer component that displays an "Add New Tag" button in autocomplete dropdowns
 * when no results are found.
 *
 * @example
 * <AddNewTagFooter
 *   searchQuery="Marketing"
 *   onAddTag={(tagName) => handleCreateTag(tagName)}
 * />
 */
export function AddNewTagFooter({ searchQuery, onAddTag }: AddNewTagFooterProps): React.ReactElement {
	return (
		<div className={css(styles.addTagDropdownFooter)}>
			<div className={css(styles.addNewTagContainer)}>
				<span className={css(styles.addNewTagLabel)}>Add New Tag: </span>
				<button className={css(styles.addNewTagPill)} onMouseDown={() => onAddTag(searchQuery)}>
					<span>{searchQuery}</span>
				</button>
			</div>
		</div>
	);
}
